import { useTranslation } from 'react-i18next'

const useTranslationLoaderBar = (text: string) => {
  const { t } = useTranslation()
  return t(text, { returnObjects: true }) as string[]
}
export default useTranslationLoaderBar
